import Container from "./SearchContainer"

export default Container